import BasePage from '../../../../../components/table_page';
import Form from './form';
import ScanList from './form/scan_list.vue';

export default {
  name: 'audit_of_banquet_tables',
  extends: BasePage,
  data() {
    return {};
  },
  components: {
    Form,
    ScanList,
  },
  created() {
    this.getConfigList('main_list');
  },
  methods: {
    // 控制按钮显示
    clickVisible({ row, val: { code } }) {
      const { banquetStatus, auditUserName } = row;
      if (code === 'approval_table' && banquetStatus !== 'ywc') {
        return false;
      }
      if (code === 'approval_table' && auditUserName) {
        return false;
      }
      return true;
    },
    modalClick({ val, row }) {
      if (val.code === 'approval_table' || val.code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = val.name || '查看';
        this.openFull();
      }
      if (val.code === 'scan_code_record') {
        this.formName = 'ScanList';
        this.propsObjInData.row = { banquetCode: row.banquetCode };
        this.modalConfig.title = '扫码记录';
        this.openFull();
      }
    },
  },
};
